import BrushIcon from '@mui/icons-material/Brush';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { Divider, Typography } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
import Drawer from "@mui/material/Drawer";
import MailIcon from "@mui/icons-material/Mail";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import HomeIcon from "@mui/icons-material/Home";
import GroupsIcon from "@mui/icons-material/Groups";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import BarChartIcon from '@mui/icons-material/BarChart';import { Box } from "@mui/system";
import './Sidebar.css';
import LunaLogo from '../img/luna-original.png';
import FacebookIcon from '@mui/icons-material/Facebook';
import ShopifyIcon from '../img/shopify.png';
import { Mail } from '@mui/icons-material';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import SmartToyIcon from '@mui/icons-material/SmartToy';

const themeColor = "url('../img/grain-texture-dark.png')";
const drawerWidth = 240;

const Sidebar = ({ window, logout, mobileOpen, handleDrawerToggle }) => {
  

  const drawer = (
    <div
      className="sidebar"
      style={{  color: "white" }}
    >

      <div className="sidebar-header">
          <img src={LunaLogo} alt="Luna Logo" width={'50px'} style={{margin: 'auto auto'}}/>
      </div>


      <Divider />

      <a href="/">
        <button className="sidebar-btn">
          {" "}
          <HomeIcon /> Dashboard{" "}
        </button>
      </a>

      <a href="./web-dm">
        <button className="sidebar-btn">
          {" "}
          <QuestionAnswerIcon /> Web Inbox{" "}
        </button>
      </a>
     
      {/* <a href="./luna-for-you">
        <button className="sidebar-btn">
          {" "}
          <SmartToyIcon /> Luna AI{" "}
        </button>
      </a>
 */}
     {/*  <a href="./instagram-dm">
        <button className="sidebar-btn">
          {" "}
          <MailIcon /> InstaBox{" "}
        </button>
      </a> */}

      <a href="./facebook-dm">
        <button className="sidebar-btn">
          {" "}
          <FacebookIcon /> FaceBox{" "}
        </button>
      </a>
     
   {/*    <a href="./mail">
        <button className="sidebar-btn">
          {" "}
          <Mail /> Mail{" "}
        </button>
      </a> */}

      <a href="./product-list" className="sidebar-off-btn-mobile">
        <button className="sidebar-btn">
          {" "}
          <FormatListBulletedIcon /> Product List{" "}
        </button>
      </a>

      <a href="./contact-list" className="sidebar-off-btn-mobile">
        <button className="sidebar-btn">
          {" "}
          <GroupsIcon /> Contact List{" "}
        </button>
      </a>
      
      <a href="./shopify-product-list" className="sidebar-off-btn-mobile">
  <button className="sidebar-btn">
    {" "}
    <img src={ShopifyIcon} alt="" width="35px" style={{ padding: '0', marginLeft: '-10px', filter: 'grayscale(100%)' }} /> Shopify{" "}
  </button>
</a>


  

      <a href="./calendar" className="sidebar-off-btn-mobile" style={{display: 'none'}}>
        <button className="sidebar-btn">
          {" "}
          <CalendarMonthIcon /> Calendar{" "}
        </button>
      </a>


    
      <a href="./data-settings">
        <button className="sidebar-btn">
          {" "}
          <BarChartIcon /> Data Settings{" "}
        </button>
      </a>
     
      {/* <a href="./edit-chat">
        <button className="sidebar-btn">
          {" "}
          <BrushIcon /> Design Editor{" "}
        </button>
      </a> */}
    

      <a href="./settings">
        <button className="sidebar-btn">
          {" "}
          <SettingsIcon /> AI Settings{" "}
        </button>
      </a>

    
   


      <>
        <button onClick={logout} className="sidebar-btn">
          {" "}
          <LogoutIcon /> Logout{" "}
        </button>
      </>


      
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;
  return (
    <Box
      component="nav"
      sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
      aria-label="mailbox folders"
    >
      {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
      <Drawer
        container={container}
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: "block", sm: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: drawerWidth,
          },
        }}
      >
        {drawer}
      </Drawer>
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: "none", sm: "block" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: drawerWidth,
          },
        }}
        open
      >
        {drawer}
      </Drawer>
    </Box>
  );
};

Sidebar.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default Sidebar;
